(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Components", [], factory);
	else if(typeof exports === 'object')
		exports["Components"] = factory();
	else
		root["Components"] = factory();
})(global, function() {
return 